import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';

import { EmailServiceComponent } from './services/mail/email.service';
import { StorageService } from './services/common/storage';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState } from './store/app.states';
import { getAuth, signOut } from 'firebase/auth';
import { FirebaseApp } from '@angular/fire/app';


 declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent {
    location: any;
    public isAdmin = false;
    public isAuthenticated:any = false;
    routerSubscription: any;
//keep refs to subscriptions to be able to unsubscribe later

constructor(private afApp:FirebaseApp,public email:EmailServiceComponent,private localStorage: StorageService, private router: Router, private store: Store<AppState>) {


       
    }

    ngOnInit(){
    
        //this.email.sendpass();
        this.recallJsFuntions();
        
    } 


 
  

  ngAfterViewInit(): void {
    // WebViewer({
    //   path: '../assets/lib', // point to where the files you copied are served from,
    //   initialDoc: "../assets/fins.pdf" // path to your document
    // }, this.element.nativeElement).then((instance) => {
    //   console.log(instance);
    // })
  }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            if(typeof $ !== 'undefined'){
            $.getScript('../assets/js/main.js');
            $('.preloader').fadeOut('slow');
            }
            this.location = this.router.url;
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            if (typeof window !== 'undefined') {
                window.scrollTo(0, 0);
                }
           
        });
    }
}